<template>

<form
  id="groupForm"
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="form-group" :class="{ 'has-error': errors.has('name') }">
    <label for="name">{{ $t('name') }}</label>
    <input
      type="text"
      id="name"
      name="name"
      class="form-control"
      :placeholder="$t('type_name')"
      v-model="group.name"
      v-validate="'required'"
    >
    <small v-show="errors.has('name')" class="form-text text-muted">
      {{ errors.first('name') }}
    </small>
  </div>

  <div class="form-group">
    <label for="permissions">{{ $t('permissions') }}</label>

    <Multiselect
      :items="permissions"
      :initialSelected="group.permissions"
      itemValue="id"
      itemText="name"
      @move="onMove"
    />
  </div>

  <div class="form-group">
    <label for="users">{{ $t('users') }}</label>

    <Multiselect
      :items="users"
      :initialSelected="group.users"
      itemValue="id"
      itemText="name"
      @move="onMoveUsers"
    />
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="onClick"
        :loading="isLoading"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Multiselect from '@/components/form/Multiselect'

export default {
  name: 'GroupForm',
  components: {
    LoaderButton,
    Multiselect
  },
  props: {
    group: {
      type: Object,
      default: () => ({
        id: undefined,
        name: '',
        permissions: [],
        users: []
      })
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.groups.isLoading,
      permissions: state => state.permission.all,
      users: state => state.users.all
    }),
    ...mapGetters('session', ['isAdmin'])
  },
  methods: {
    ...mapActions('groups', [
      'create',
      'edit',
      'cleanState'
    ]),

    onMove (permissions) {
      this.group.permissions = permissions.map(({ id }) => id)
    },

    onMoveUsers (users) {
      this.group.users = users.map(({ id }) => id)
    },

    async onClick (evtClick, doneFn) {
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.group

      let requestData
      if (this.isAdmin) {
        requestData = this.group
      } else {
        requestData = {
          name: this.group.name,
          permissions: this.group.permissions,
          users: this.group.users
        }
      }

      let promise
      if (id) {
        promise = this.edit({ id, data: requestData })
      } else {
        promise = this.create(requestData)
      }
      const result = await promise
      if (result) {
        this.$router.push({ name: 'listgroups' })
      }
    }
  },
  mounted () {
    this.$store.dispatch('users/fetchAll')
    this.$store.dispatch('permission/fetchAll')
  },
  destroyed () {
    // this.isAdmin
    this.$store.dispatch('permission/cleanState')
    this.cleanState()
  }
}
</script>
